import React, { useState } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import Section from '@hero/ui-kit/layout/Section';
import QueryInlineError from '../../../../components/QueryInlineError';
import InlineLoader from '../../../../components/InlineLoader';
import useMarkTemplate from '../../api/useMarkTemplate';
import { MarkPageHeader } from '../../components/MarkLayout';
import TemplateEditorShell from '../../components/BlockEditor/TemplateEditorShell';
import type { MarkTemplateRow } from '../../types';
import * as layout from '../../components/markLayout.module.css';

const EditTemplate: React.FC = () => {
    const { templateId } = useParams();
    const id = Number(templateId);
    const validId = Number.isInteger(id) && id > 0;
    const query = useMarkTemplate(validId ? id : null);
    const [initial, setInitial] = useState<{ id: number; row: MarkTemplateRow } | null>(null);
    if (validId && !query.isFetching && query.data && initial?.id !== id)
        setInitial({ id, row: query.data.data });
    const location = useLocation();
    const from = (location.state as { from?: string } | null)?.from ?? '/mark/templates';
    if (!validId) return <p role="alert">Invalid template ID.</p>;
    const row = initial?.id === id ? initial.row : null;
    if (query.error && !query.data && !row) return <QueryInlineError error={query.error} />;
    if (!row) return <InlineLoader />;
    if (
        (row.format !== 'html' && row.format !== 'blocks') ||
        row.channel !== 'email' ||
        row.blast_variant_id != null ||
        row.drip_version_id != null
    )
        return <p role="alert">Open this template from its campaign.</p>;
    return (
        <Section className={layout.page} subtheme={['regular', 'background']} noDefaultPadding>
            <MarkPageHeader title="Edit template">
                <Link to={from}>Back to templates</Link>
            </MarkPageHeader>
            {query.error && <QueryInlineError error={query.error} />}
            <TemplateEditorShell
                key={id}
                library
                channel="email"
                markTemplate={row}
                templateId={id}
                templateLoadState="existing"
            />
        </Section>
    );
};

export default EditTemplate;
